<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('overview.register_new_system') }}</h4>
        </dialog-header>

        <form name="newSystemForm" novalidate @submit.prevent="submit()">
            <div class="ngdialog__body">
                <fieldset class="form__group">
                    <div class="row form__row">
                        <div class="column-mobile-24">
                            <label class="form__label" for="serial_number">
                                {{ $t('fields.serial_number') }}
                            </label>
                            <input
                                type="text"
                                class="form__field"
                                id="serial_number"
                                name="serial_number"
                                v-model.trim.lazy="$v.formData.serial_number.$model"
                                required
                                minlength="17"
                                maxlength="21"
                                @blur="checkSerial()"
                                @input="clearRemoteError('serial_number')"
                                :class="{
                                    'is-invalid': $v.formData.serial_number.$invalid || lengthError,
                                    'is-dirty': $v.formData.serial_number.$dirty || lengthError,
                                }"
                            />

                            <div v-if="$v.formData.serial_number.$dirty || lengthError">
                                <p class="form__error" v-if="!$v.formData.serial_number.required">
                                    {{ $t('fields.serial_number_e_required') }}
                                </p>

                                <p
                                    class="form__error"
                                    v-if="!$v.formData.serial_number.minLength || lengthError"
                                >
                                    {{ $t('fields.serial_number_e_length') }}
                                </p>

                                <p class="form__error" v-if="!$v.formData.serial_number.maxLength">
                                    {{ $t('fields.serial_number_e_length') }}
                                </p>

                                <p class="form__error" v-if="!$v.formData.serial_number.remote">
                                    {{ remoteErrors.serial_number[0] }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row form__row">
                        <div class="column-mobile-24">
                            <label class="form__label" for="mac_address">
                                {{ $t('fields.mac_address') }}
                            </label>
                            <input
                                type="text"
                                class="form__field"
                                id="mac_address"
                                name="mac_address"
                                v-model.trim.lazy="$v.formData.mac_address.$model"
                                required
                                @input="clearRemoteError('mac_address')"
                                :class="{
                                    'is-invalid': $v.formData.mac_address.$invalid,
                                    'is-dirty': $v.formData.mac_address.$dirty,
                                }"
                            />

                            <div v-if="$v.formData.mac_address.$dirty">
                                <p class="form__error" v-if="!$v.formData.mac_address.required">
                                    {{ $t('fields.mac_address_e_required') }}
                                </p>

                                <p class="form__error" v-if="!$v.formData.mac_address.remote">
                                    {{ remoteErrors.mac_address[0] }}
                                </p>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>

            <dialog-buttons :submit-text="$t('overview.register_system')" />
        </form>
    </div>
</template>

<script>
import * as api from '@/api';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import remote from '@/validators/remote';
import DialogHeader from '@/components/DialogHeader';
import DialogButtons from '@/components/DialogButtons';

export default {
    components: {
        DialogHeader,
        DialogButtons,
    },
    data() {
        return {
            remoteErrors: null,
            formData: {
                serial_number: '',
                mac_address: '',
            },
            lengthError: false,
        };
    },
    validations() {
        return {
            formData: {
                serial_number: {
                    required,
                    minLength: minLength(17),
                    maxLength: maxLength(21),
                    remote: remote(this.remoteErrors, 'serial_number'),
                },
                mac_address: {
                    required,
                    remote: remote(this.remoteErrors, 'mac_address'),
                },
            },
        };
    },
    methods: {
        submit() {
            this.remoteErrors = null;

            if (!this.checkSerial()) {
                this.$v.formData.$touch();
                return;
            }

            if (this.$v.formData.$invalid) {
                this.$v.formData.$touch();
                return;
            }

            api.systems
                .create({
                    country: '',
                    mac_address: this.formData.mac_address,
                    serial_number: this.formData.serial_number,
                })
                .then(
                    response => {
                        this.$emit('close');

                        this.$router.push({
                            name: 'system-management',
                            params: { id: response.data.id },
                        });
                    },
                    error => {
                        this.remoteErrors = error.response.data.errors;
                    }
                );
        },
        checkSerial() {
            this.lengthError = false;

            const retval =
                this.formData.serial_number.length === 17 ||
                this.formData.serial_number.length === 19 ||
                this.formData.serial_number.length === 21;

            if (retval === false) this.lengthError = true;

            return retval;
        },
        clearRemoteError(key) {
            if (this.remoteErrors && this.remoteErrors[key]) {
                this.remoteErrors[key] = null;
            }
        },
    },
};
</script>
